import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../contexts/ThemeContext';
import { alpha, makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{paddingTop:"16px"}}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};



const TabsHomePage = ({ children, children2 }) => {
  const theme = useContext(ThemeContext);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      border: "2px solid #E6E6E6",
      borderRadius: "8px",
      [theme.breakpoints.up('lg')]: {
        maxWidth: "1900px"
      },
      [theme.breakpoints.down('lg')]: {
        maxWidth: "80%"
      },
    },
    appBar: {
      color: "black",
      boxShadow: "none",
      borderBottom: "2px solid #E6E6E6"
    }
  }));

  const StyledTabs = withStyles({
    indicator: {
      backgroundColor: `${theme.textButton}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
  })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

  const StyledTab = withStyles(() => ({
    root: {
      display: 'flex',
      marginLeft: '18%',
      color: `${theme.textButton}`,
      '&:hover': {
        backgroundColor:'rgba(255, 255, 255, 0.5)',
        color:'white'
      },
    },
  }))((props) => <Tab disableRipple {...props} style={{ outline: "none", }} />);


  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [valueSwitch, setValueSwitch] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setValueSwitch(newValue);
  };

  return (
    <>
      <AppBar
        style={{
          backgroundColor: `${theme.primary}`,
          marginTop: "0",
          borderRadius: "8px 8px 0px 0px",
          display: "flex",
          justifyContent: "space-between"
        }}
        className={classes.appBar}
        position="static"
      >
        <StyledTabs
          value={value}
          onChange={handleChange}
        >
          <StyledTab label="RECURSOS PEDAGÓGICOS E ITENS" {...a11yProps(0)} />
          <StyledTab label="TRILHAS ADAPTATIVAS, AVALIAÇÕES E ATIVIDADES" {...a11yProps(1)} />
        </StyledTabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {children}
      </TabPanel>
    
      <TabPanel value={value} index={1}>
        {children2}
      </TabPanel>
    </>
  );
}
export default TabsHomePage;
